/**
 * Registers a tab-close guard when a retreat is running.
 *
 * Desktop (Chrome, Firefox, Safari): beforeunload fires and shows the browser's
 * native "Leave site?" dialog.
 *
 * Mobile (iOS Safari, Chrome Android): beforeunload is intentionally blocked by
 * the browser — it never fires. There is no API that can block a tab close on
 * mobile; the reliable defense there is the engine's persist-to-IDB strategy
 * combined with the returning-user resume flow.
 */
import { useEffect } from "react";

export function useBeforeUnload(isRunning: boolean): void {
  useEffect(() => {
    if (!isRunning) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "A retreat is in progress. Are you sure you want to leave?";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isRunning]);
}
